module.exports = __webpack_public_path__ + "static/img/s2.0e3c60e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/custom/s2.png
// module id = Gbpy
// module chunks = 0